function openAccordion() {
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('open-accordion') ||
            event.target.classList.contains('close-accordion')) {

            const accordionMain = event.target.closest('.accordion-main');

            if (accordionMain) {
                const accordionInner = accordionMain.querySelector('.accordion-inner');
                // Используем querySelectorAll для всех кнопок
                const openBtns = accordionMain.querySelectorAll('.open-accordion');
                const closeBtns = accordionMain.querySelectorAll('.close-accordion');
                const textElements = accordionMain.querySelectorAll('h4, p, li');

                if (accordionInner && openBtns.length && closeBtns.length) {
                    const isOpen = accordionInner.classList.contains('open');

                    if (isOpen) {
                        accordionInner.classList.remove('open');
                        accordionMain.classList.remove('accordion-container-open');
                        textElements.forEach(el => {
                            el.classList.remove('text-color-white');
                            el.style.removeProperty('color');
                        });

                        setTimeout(() => {
                            // Показываем все кнопки открытия
                            openBtns.forEach(btn => {
                                btn.style.display = 'inline-block';
                            });
                            // Скрываем все кнопки закрытия
                            closeBtns.forEach(btn => {
                                btn.style.display = 'none';
                            });
                        }, 150);
                    } else {
                        accordionInner.classList.add('open');
                        accordionMain.classList.add('accordion-container-open');
                        textElements.forEach(el => {
                            el.classList.add('text-color-white');
                            el.style.setProperty('color', 'white', 'important');
                        });
                        // Скрываем все кнопки открытия
                        openBtns.forEach(btn => {
                            btn.style.display = 'none';
                        });
                        // Показываем все кнопки закрытия
                        closeBtns.forEach(btn => {
                            btn.style.display = 'inline-block';
                        });
                    }
                }
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', openAccordion);

export { openAccordion };